import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const PostContainer = styled.li`
  display: flex;
  flex-direction: row;
  gap: ${SPACING._16};
  align-items: start;
  width: 100%;
  padding-right: ${SPACING._8};
  padding: ${SPACING._4};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._4};
  width: 100%;

  > header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${SPACING._6};

    #right {
      margin-left: auto;
      @media (max-width: 450px) {
        margin-left: 0;
      }
    }

    @media (max-width: 450px) {
      flex-direction: column;
      align-items: baseline;
    }
  }

  img {
    width: 100%;
    max-height: 200px;
    object-fit: cover;
    transition: 200ms;
    &:hover {
      scale: 1.01;
    }
  }
`;
